module.exports = __webpack_public_path__ + "static/media/Hulk 3.de6aa05e.jpg";